<template>
  <div>
    <div class="mb-4">
      <v-btn color="grey" variant="text"to="/dailyreport/child"> Back to List </v-btn>
    </div>
    <div>
      <div class="d-flex align-center">
        <h1 v-if="diary" class="mr-8">
          {{ diary.child.lastName }} {{ diary.child.firstName }}
        </h1>
        <h3>{{ displayDate }}</h3>
        <v-spacer></v-spacer>
        </div>
      <v-row v-if="report" class="my-4">
        <v-col cols="4">
          <h2>At Home</h2>
          <v-table class="report-table">
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left">Item</th>
                  <th class="text-left">Content</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td class="report-table-header">Sleep</td>
                  <td>
                    <div
                      v-for="sleep in report.home.sleeps"
                      :key="sleep.sleepId"
                    >
                      {{ sleep ? formatDate(sleep.from) : "" }} ~
                      {{ sleep ? formatDate(sleep.to) : "" }}
                    </div>
                  </td>
                </tr>
                <tr>
                  <td class="report-table-header">Defecation</td>
                  <td>
                    <div
                      v-for="defecation in report.home.defecations"
                      :key="defecation.defecationId"
                    >
                      <span class="grey--text mr-2">
                        {{
                          defecation ? formatDate(defecation.recordedAt) : ""
                        }}
                      </span>
                      <span class="">
                        {{
                          defecation ? formatDefecation(defecation.state) : ""
                        }}
                      </span>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td class="report-table-header">Temperature</td>
                  <td>
                    <div
                      v-for="temperature in report.home.temperatures"
                      :key="temperature.temperatureId"
                    >
                      <span class="grey--text mr-2">
                        {{
                          temperature ? formatDate(temperature.recordedAt) : ""
                        }}
                      </span>
                      <span class="">
                        {{
                          temperature
                            ? formatTemperature(temperature.temperature)
                            : ""
                        }}℃
                      </span>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td class="report-table-header">Dinner</td>
                  <td>
                    <div
                      v-for="dinner in report.home.dinners"
                      :key="dinner.dinnerId"
                    >
                      {{ dinner.content }}
                    </div>
                  </td>
                </tr>
                <tr>
                  <td class="report-table-header">Breakfast</td>
                  <td>
                    <div
                      v-for="breakfast in report.home.breakfasts"
                      :key="breakfast.breakfastId"
                    >
                      {{ breakfast.content }}
                    </div>
                  </td>
                </tr>
                <tr>
                  <td class="report-table-header">Milk</td>
                  <td>
                    <div v-for="milk in report.home.milks" :key="milk.milkId">
                      <span class="grey--text mr-2">
                        {{ milk ? formatDate(milk.recordedAt) : "" }}
                      </span>
                      <span class="">
                        {{ milk.amount ? milk.amount.value : "(Unknown)" }}cc
                      </span>
                    </div>
                  </td>
                </tr>
              </tbody>
            </template>
          </v-table>
        </v-col>

        <v-col cols="4">
          <h2>At Nursery</h2>
          <v-table class="report-table">
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left">Item</th>
                  <th class="text-left">Content</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td class="report-table-header">Check-in Time</td>
                  <td>
                    {{ attendance ? formatDate(attendance.attendedAt) : "" }}
                  </td>
                </tr>
                <tr>
                  <td class="report-table-header">Check-out Time</td>
                  <td>{{ attendance ? formatDate(attendance.leftAt) : "" }}</td>
                </tr>
                <tr>
                  <td class="report-table-header">Defecation</td>
                  <td>
                    <div
                      v-for="defecation in report.nursery.defecations"
                      :key="defecation.defecationId"
                    >
                      <div class="d-inline" @click="changeEditDefecation(defecation)">
                        <span class="grey--text mr-2">
                          {{
                            defecation ? formatDate(defecation.recordedAt) : ""
                          }}
                        </span>
                        <span class="">
                          {{
                            defecation ? formatDefecation(defecation.state) : ""
                          }}
                        </span>
                      </div>
                      <div v-if="report.nursery.defecations.at(-1)?.defecationId == defecation.defecationId" class="d-inline pl-6">
                        <v-btn
                          size="x-small"
                          variant="outlined"                       
                          color="primary"
                          @click="changeAddOtherRecord('defecation')"
                          :disabled="loading"
                        >
                          + Add Record
                        </v-btn>
                      </div>
                    </div>
                    <div v-if="!report.nursery.defecations.length">
                      <v-btn
                        size="small"
                        variant="outlined"
                        color="primary"
                        @click="changeAddOtherRecord('defecation')"
                        :disabled="loading"
                      >
                        + Add Record
                      </v-btn>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td class="report-table-header">Temperature</td>
                  <td>
                    <div
                      v-for="temperature in report.nursery.temperatures"
                      :key="temperature.temperatureId"
                    >
                      <div class="d-inline" @click="changeEditTemperature(temperature)">
                        <span class="grey--text mr-2">
                          {{
                            temperature ? formatDate(temperature.recordedAt) : ""
                          }}
                        </span>
                        <span class="">
                          {{
                            temperature
                              ? formatTemperature(temperature.temperature)
                              : ""
                          }}℃
                        </span>
                      </div>
                      <div v-if="report.nursery.temperatures.at(-1)?.temperatureId == temperature.temperatureId" class="d-inline pl-6">
                        <v-btn
                          size="x-small"
                          variant="outlined"
                          color="primary"
                          @click="changeAddOtherRecord('temperature')"
                          :disabled="loading"
                        >
                          + Add Record
                        </v-btn>
                      </div>
                    </div>
                    <div v-if="!report.nursery.temperatures.length">
                      <v-btn
                        size="small"
                        variant="outlined"
                        color="primary"
                        @click="changeAddOtherRecord('temperature')"
                        :disabled="loading"
                      >
                        + Add Record
                      </v-btn>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td class="report-table-header">Milk</td>
                  <td>
                    <div
                      v-for="milk in report.nursery.milks"
                      :key="milk.milkId"
                    >
                      <div class="d-inline" @click="changeEditMilk(milk)">
                        <span class="grey--text mr-2">
                          {{ milk ? formatDate(milk.recordedAt) : "" }}
                        </span>
                        <span class="">
                          {{ milk.amount ? milk.amount.value : "(Unknown)" }}cc
                        </span>
                      </div>
                      <div v-if="report.nursery.milks.at(-1)?.milkId == milk.milkId" class="d-inline pl-6">
                        <v-btn
                          size="x-small"
                          variant="outlined"
                          color="primary"
                          @click="changeAddOtherRecord('milk')"
                          :disabled="loading"
                        >
                          + Add Record
                        </v-btn>
                      </div>
                    </div>
                    <div v-if="!report.nursery.milks.length">
                      <v-btn
                        size="small"
                        variant="outlined"
                        color="primary"
                        @click="changeAddOtherRecord('milk')"
                        :disabled="loading"
                      >
                        + Add Record
                      </v-btn>
                    </div>
                  </td>
                </tr>
              </tbody>
            </template>
          </v-table>
        </v-col>

        <v-col cols="4">
          <h2 class="d-inline">Meals</h2>
          <template v-if="!report.nursery.meal">
            <span class="d-inline pl-6">
              <v-btn
                size="small"
                variant="outlined"
                color="primary"
                @click="createMealReport()"
                :disabled="loading"
              >
                + Add Record
              </v-btn>
            </span>
          </template>
          <template v-else>
            <span class="d-inline pl-6">
              <v-btn
                size="default"
                variant="text"
                color="primary"
                height="20"
                @click="fullEat()"
                :disabled="loading"
              >
                Ate All
              </v-btn>
            </span>
          </template>
          <v-table class="report-table">
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left">Item</th>
                  <th class="text-left">Content</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td class="report-table-header">Staple Food</td>
                  <td v-if="report.nursery.meal && mealRecord.stapleFood">
                    <div @click="showMenu('stapleFood')" >
                      <v-menu v-model="showMenuItem.stapleFood" location="bottom" max-width="290px">
                        <template v-slot:activator="{ props }">
                          <div class="d-flex " v-bind="props" style="position: relative">
                            {{ formatMealStatus(mealRecord.stapleFood)}}
                          </div>
                        </template>
                        <v-list>
                          <v-list-item v-for="(s, index) in statusList" :key="index" @click="changeMealStatus('stapleFood', s.status)">
                            <v-list-item-title>
                              <div class="d-flex align-center" >
                                <div class="d-flex flex-column align-center">
                                  <div class="d-flex" style="position: relative">
                                    <div :class="`circle-back-${s.status}`"></div>
                                    <div :class="`circle-front-${s.status}`"></div>
                                  </div>
                                </div>
                                <div class="ml-3">{{ s.title }}</div>
                              </div>
                            </v-list-item-title>
                          </v-list-item>
                        </v-list>
                      </v-menu>
                    </div>
                  </td>
                  <td v-else>
                    {{ "" }}
                  </td>
                </tr>
                <tr>
                  <td class="report-table-header">Main Dish</td>
                  <td v-if="report.nursery.meal && mealRecord.mainDish">
                    <div @click="showMenu('mainDish')">
                      <v-menu v-model="showMenuItem.mainDish" location="bottom" max-width="290px">
                        <template v-slot:activator="{ props }">
                          <div class="d-flex flex-column" v-bind="props">
                            <div class="d-flex" style="position: relative">
                              {{ formatMealStatus(mealRecord.mainDish)}}
                            </div>
                          </div>
                        </template>
                        <v-list>
                          <v-list-item v-for="(s, index) in statusList" :key="index" @click="changeMealStatus('mainDish', s.status)">
                            <v-list-item-title>
                              <div class="d-flex align-center" >
                                <div class="d-flex flex-column align-center">
                                  <div class="d-flex" style="position: relative">
                                    <div :class="`circle-back-${s.status}`"></div>
                                    <div :class="`circle-front-${s.status}`"></div>
                                  </div>
                                </div>
                                <div class="ml-3">{{ s.title }}</div>
                              </div>
                            </v-list-item-title>
                          </v-list-item>
                        </v-list>
                      </v-menu>
                    </div>
                  </td>
                  <td v-else>
                    {{ "" }}
                  </td>
                </tr>
                <tr>
                  <td class="report-table-header">Side Dish</td>
                  <td v-if="report.nursery.meal && mealRecord.sideDish">
                    <div @click="showMenu('sideDish')">
                      <v-menu v-model="showMenuItem.sideDish" location="bottom" max-width="290px">
                        <template v-slot:activator="{ props }">
                          <div class="d-flex flex-column" v-bind="props">
                            <div class="d-flex" style="position: relative">
                              {{ formatMealStatus(mealRecord.sideDish)}}
                            </div>
                          </div>
                        </template>
                        <v-list>
                          <v-list-item v-for="(s, index) in statusList" :key="index" @click="changeMealStatus('sideDish', s.status)">
                            <v-list-item-title>
                              <div class="d-flex align-center" >
                                <div class="d-flex flex-column align-center">
                                  <div class="d-flex" style="position: relative">
                                    <div :class="`circle-back-${s.status}`"></div>
                                    <div :class="`circle-front-${s.status}`"></div>
                                  </div>
                                </div>
                                <div class="ml-3">{{ s.title }}</div>
                              </div>
                            </v-list-item-title>
                          </v-list-item>
                        </v-list>
                      </v-menu>
                    </div>
                  </td>
                  <td v-else>
                    {{ "" }}
                  </td>
                </tr>
                <tr>
                  <td class="report-table-header">Soup</td>
                  <td v-if="report.nursery.meal && mealRecord.soup">
                    <div @click="showMenu('soup')">
                      <v-menu v-model="showMenuItem.soup" location="bottom" max-width="290px">
                        <template v-slot:activator="{ props }">
                          <div class="d-flex flex-column" v-bind="props">
                            <div class="d-flex" style="position: relative">
                              {{ formatMealStatus(mealRecord.soup)}}
                            </div>
                          </div>
                        </template>
                        <v-list>
                          <v-list-item v-for="(s, index) in statusList" :key="index" @click="changeMealStatus('soup', s.status)">
                            <v-list-item-title>
                              <div class="d-flex align-center" >
                                <div class="d-flex flex-column align-center">
                                  <div class="d-flex" style="position: relative">
                                    <div :class="`circle-back-${s.status}`"></div>
                                    <div :class="`circle-front-${s.status}`"></div>
                                  </div>
                                </div>
                                <div class="ml-3">{{ s.title }}</div>
                              </div>
                            </v-list-item-title>
                          </v-list-item>
                        </v-list>
                      </v-menu>
                    </div>
                  </td>
                  <td v-else>
                    {{ "" }}
                  </td>
                </tr>
                <tr>
                  <td class="report-table-header">Dessert</td>
                  <td v-if="report.nursery.meal && mealRecord.dessert">
                    <div @click="showMenu('dessert')">
                      <v-menu v-model="showMenuItem.dessert" location="bottom" max-width="290px">
                        <template v-slot:activator="{ props }">
                          <div class="d-flex flex-column" v-bind="props">
                            <div class="d-flex" style="position: relative">
                              {{ formatMealStatus(mealRecord.dessert)}}
                            </div>
                          </div>
                        </template>
                        <v-list>
                          <v-list-item v-for="(s, index) in statusList" :key="index" @click="changeMealStatus('dessert', s.status)">
                            <v-list-item-title>
                              <div class="d-flex align-center" >
                                <div class="d-flex flex-column align-center">
                                  <div class="d-flex" style="position: relative">
                                    <div :class="`circle-back-${s.status}`"></div>
                                    <div :class="`circle-front-${s.status}`"></div>
                                  </div>
                                </div>
                                <div class="ml-3">{{ s.title }}</div>
                              </div>
                            </v-list-item-title>
                          </v-list-item>
                        </v-list>
                      </v-menu>
                    </div>
                  </td>
                  <td v-else>
                    {{ "" }}
                  </td>
                </tr>
                <tr>
                  <td class="report-table-header">Cow Milk</td>
                  <td v-if="report.nursery.meal && mealRecord.milk">
                    <div @click="showMenu('milk')">
                      <v-menu v-model="showMenuItem.milk" location="bottom" max-width="290px">
                        <template v-slot:activator="{ props }">
                          <div class="d-flex flex-column" v-bind="props">
                            <div class="d-flex" style="position: relative">
                              {{ formatMealStatus(mealRecord.milk)}}
                            </div>
                          </div>
                        </template>
                        <v-list>
                          <v-list-item v-for="(s, index) in statusList" :key="index" @click="changeMealStatus('milk', s.status)">
                            <v-list-item-title>
                              <div class="d-flex align-center" >
                                <div class="d-flex flex-column align-center">
                                  <div class="d-flex" style="position: relative">
                                    <div :class="`circle-back-${s.status}`"></div>
                                    <div :class="`circle-front-${s.status}`"></div>
                                  </div>
                                </div>
                                <div class="ml-3">{{ s.title }}</div>
                              </div>
                            </v-list-item-title>
                          </v-list-item>
                        </v-list>
                      </v-menu>
                    </div>
                  </td>
                  <td v-else>
                    {{ "" }}
                  </td>
                </tr>
                <tr>
                  <td class="report-table-header">Snack</td>
                  <td v-if="report.nursery.meal && mealRecord.snack">
                    <div @click="showMenu('snack')">
                      <v-menu v-model="showMenuItem.snack" location="bottom" max-width="290px">
                        <template v-slot:activator="{ props }">
                          <div class="d-flex flex-column" v-bind="props">
                            <div class="d-flex" style="position: relative">
                              {{ formatMealStatus(mealRecord.snack)}}
                            </div>
                          </div>
                        </template>
                        <v-list>
                          <v-list-item v-for="(s, index) in statusList" :key="index" @click="changeMealStatus('snack', s.status)">
                            <v-list-item-title>
                              <div class="d-flex align-center" >
                                <div class="d-flex flex-column align-center">
                                  <div class="d-flex" style="position: relative">
                                    <div :class="`circle-back-${s.status}`"></div>
                                    <div :class="`circle-front-${s.status}`"></div>
                                  </div>
                                </div>
                                <div class="ml-3">{{ s.title }}</div>
                              </div>
                            </v-list-item-title>
                          </v-list-item>
                        </v-list>
                      </v-menu>
                    </div>
                  </td>
                  <td v-else>
                    {{ "" }}
                  </td>
                </tr>
              </tbody>
            </template>
          </v-table>
        </v-col>
      </v-row>

      <h3>Activity Record & Development</h3>
      <div class="d-flex">
        <v-textarea
          v-if="diary"
          v-model="content"
          variant="outlined"
        ></v-textarea>
        <div class="align-center justify-center pa-15">
          <v-btn
            color="primary"
            variant="outlined"
            class=""
            @click="saveContent"
            :disabled="!isSaveContent"
            :loading="loading"
          >
            Save
          </v-btn>
        </div>
      </div>
    </div>

    <v-dialog v-model="addRecordDialog" max-width="720">
      <v-card>
        <v-card-title class="align-center justify-center">
          Add Record
        </v-card-title>
        <v-card-text>

          <template v-if="otherRecord == 'defecation'">
            <div class="d-flex align-center justify-center mb-5">
              <v-chip color="#02c07c" variant="outlined" size="small">Defecation</v-chip>
            </div>
            
            <v-menu
              v-model="isRecordetAtPicker"
              :close-on-content-click="false"
              transition="scale-transition"
              location="bottom" max-width="290px"
              min-width="290px"
            >
              <template v-slot:activator="{ props }">
                <v-text-field
                  v-model="recordedAt"
                  label="Time"
                  prepend-icon="mdi-clock-time-four-outline"
                  :rules="[rules]"
                  readonly
                  v-bind="props"
                  variant="outlined"
                  density="compact"
                  class="mb-3"
                ></v-text-field>
              </template>
              
                <v-time-picker
                  v-if="isRecordetAtPicker"
                  v-model="recordedAt"
                  @update:modelValue="(val) => { changeRecordedAt(val); isRecordetAtPicker = false; }"
                  full-width
                  format="24hr" 
                  :allowed-minutes="allowedStep"
                ></v-time-picker>
            </v-menu>

            <v-select
              v-model="defecation"
              @update:modelValue="changeDefecationState"
              :items="choices"
              item-title="text"
              item-value="value"
              :rules="[rules]"
              label="State"
              variant="outlined"
              density="compact"
            >
            </v-select>
          </template>

          <template v-if="otherRecord == 'temperature'">
            <div class="d-flex align-center justify-center mb-5">
              <v-chip color="#eb2121" variant="outlined" size="small">Temperature</v-chip>
            </div>
            <v-menu
              v-model="isRecordetAtPicker"
              :close-on-content-click="false"
              transition="scale-transition"
              location="bottom"
              max-width="290px"
              min-width="290px"
            >
              <template v-slot:activator="{ props }">
                <v-text-field
                  v-model="recordedAt"
                  label="Time"
                  prepend-icon="mdi-clock-time-four-outline"
                  :rules="[rules]"
                  readonly
                  v-bind="props"
                  variant="outlined"
                  density="compact"
                  class="mb-3"
                ></v-text-field>
              </template>
              <v-time-picker
                v-if="isRecordetAtPicker"
                v-model="recordedAt"
                @update:modelValue="(val) => { changeRecordedAt(val); isRecordetAtPicker = false; }"
                full-width
                format="24hr"
                :allowed-minutes="allowedStep"
              ></v-time-picker>
            </v-menu>
            <div class="d-flex align-baseline">
              <v-select
                v-model="temperature"
                @update:modelValue="changeTemperature"
                :items="optionsTemperature"
                item-title="text"
                item-value="value"
                :rules="[rules]"
                label="Temperature"
                :menu-props="{ auto: true }"
                variant="outlined"
                density="compact"
              ></v-select>
              <p class="ml-1 body-1">℃</p>
            </div>
          </template>

          <template v-if="otherRecord == 'milk'">
            <div class="d-flex align-center justify-center mb-5">
              <v-chip color="#db069f" variant="outlined" size="small">Milk</v-chip>
            </div>
            <v-menu
              v-model="isRecordetAtPicker"
              :close-on-content-click="false"
              transition="scale-transition"
              location="bottom"
              max-width="290px"
              min-width="290px"
            >
              <template v-slot:activator="{ props }">
                <v-text-field
                  v-model="recordedAt"
                  label="Time"
                  prepend-icon="mdi-clock-time-four-outline"
                  :rules="[rules]"
                  readonly
                  v-bind="props"
                  variant="outlined"
                  density="compact"
                  class="mb-3"
                ></v-text-field>
              </template>
              <v-time-picker
                v-if="isRecordetAtPicker"
                v-model="recordedAt"
                @update:modelValue="(val) => { changeRecordedAt(val); isRecordetAtPicker = false; }"
                full-width
                format="24hr"
                :allowed-minutes="allowedStep"
              ></v-time-picker>
            </v-menu>

            <div class="d-flex align-baseline mb-3">
              <v-select
                v-model="amount"
                @update:modelValue="changeAmount"
                :items="milkChoice"
                item-title="value"
                item-value="id"
                :rules="[rules]"
                label="Amount"
                variant="outlined"
                density="compact"
              ></v-select>
              <p class="ml-1 body-1">cc</p>
            </div>

            <div class="d-flex align-baseline">
              <v-select
                v-model="milkCategory"
                @update:modelValue="changeMilkCategory"
                :items="optionsMilk"
                item-title="text"
                item-value="value"
                :rules="[rules]"
                label="Milk"
                variant="outlined"
                density="compact"
              ></v-select>
            </div>
          </template>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-row class="mt-2 mb-2">
            <v-col cols="6" class="pr-2 pl-2">
              <v-btn class="" color="#6C6C6C" dark variant="flat" width="100%" @click="addRecordDialog = false">
                <div>
                  <div class="text-h6 font-weight-bold message-btn">Cancel</div>
                </div>
              </v-btn>
            </v-col>

            <v-col cols="6" class="pl-1 pr-2">
              <v-btn
                class=""
                color="primary"
                variant="flat"
                width="100%"
                @click="save(otherRecord)"
                :disabled="!isSaveOtherRecord"
                :loading="loading"
              >
                <div>
                  <div class="text-h6 font-weight-bold message-btn">Save</div>
                </div>
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="editRecordDialog" max-width="720">
      <v-card>
        <v-card-title class="align-center justify-center">
          Edit & Delete Record
        </v-card-title>
        <v-card-text>

          <template v-if="otherRecord == 'defecation'">
            <div v-if="defecationRecord" class="d-flex align-center justify-center mb-5">
              <div>Before: 
                <v-chip color="#02c07c" variant="outlined" size="small">Defecation</v-chip>
              </div>
              <div class="ml-4">{{ formatTime(defecationRecord?.recordedAt) }}</div>
              <div class="ml-4">{{ formatDefecation(defecationRecord.state) }}</div>
            </div>
            <v-menu
              v-model="editRecordAtPicker"
              :close-on-content-click="false"
              transition="scale-transition"
              location="bottom"
              max-width="290px"
              min-width="290px"
            >
              <template v-slot:activator="{ props }">
                <v-text-field
                  v-model="recordedAt"
                  label="Time"
                  prepend-icon="mdi-clock-time-four-outline"
                  :rules="[rules]"
                  readonly
                  v-bind="props"
                  variant="outlined"
                  density="compact"
                  class="mb-3"
                ></v-text-field>
              </template>
                <v-time-picker
                  v-if="editRecordAtPicker"
                  v-model="recordedAt"
                  @update:modelValue="(val) => { changeRecordedAt(val); editRecordAtPicker = false; }"
                  full-width
                  format="24hr"
                  :allowed-minutes="allowedStep"
                ></v-time-picker>
            </v-menu>

            <v-select
              v-model="defecation"
              @update:modelValue="changeDefecationState"
              :items="choices"
              item-title="text"
              item-value="value"
              :rules="[rules]"
              label="State"
              variant="outlined"
              density="compact"
            >
            </v-select>
          </template>

          <template v-if="otherRecord == 'temperature'">
            <div v-if="temperatureRecord" class="d-flex align-center justify-center mb-5">
              <div>Before: 
                <v-chip color="#eb2121" variant="outlined" size="small">Temperature</v-chip>
              </div>
              <div class="ml-4">{{ formatTime(temperatureRecord?.recordedAt) }}</div>
              <div class="ml-4">{{ formatTemperature(temperatureRecord.temperature) }}℃</div>
            </div>
            <v-menu
              v-model="editRecordAtPicker"
              :close-on-content-click="false"
              transition="scale-transition"
              location="bottom"
              max-width="290px"
              min-width="290px"
            >
              <template v-slot:activator="{ props }">
                <v-text-field
                  v-model="recordedAt"
                  label="Time"
                  prepend-icon="mdi-clock-time-four-outline"
                  :rules="[rules]"
                  readonly
                  v-bind="props"
                  variant="outlined"
                  density="compact"
                  class="mb-3"
                ></v-text-field>
              </template>
              <v-time-picker
                v-if="editRecordAtPicker"
                v-model="recordedAt"
                @update:modelValue="(val) => { changeRecordedAt(val); editRecordAtPicker = false; }"
                full-width
                format="24hr"
                :allowed-minutes="allowedStep"
              ></v-time-picker>
            </v-menu>

            <div class="d-flex align-baseline">
              <v-select
                v-model="temperature"
                @update:modelValue="changeTemperature"
                :items="optionsTemperature"
                item-title="text"
                item-value="value"
                :rules="[rules]"
                label="Temperature"
                :menu-props="{ auto: true }"
                variant="outlined"
                density="compact"
              ></v-select>
              <p class="ml-1 body-1">℃</p>
            </div>
          </template>

          <template v-if="otherRecord == 'milk'">
            <div v-if="milkRecord" class="d-flex align-center justify-center">
              <div>Before: 
                <v-chip color="#db069f" variant="outlined" size="small">Milk</v-chip>
              </div>
              <div class="ml-4">{{ formatTime(milkRecord?.recordedAt) }}</div>
            </div>
            <div v-if="milkRecord" class="d-flex align-center justify-center mb-5">
              <div class="ml-4">{{ milkRecord.amount?.value }}cc</div>
              <div class="ml-4" v-if="milkRecord.milkCategory == 'formula'">Formula</div>
              <div class="ml-4" v-if="milkRecord.milkCategory == 'breast'">Breast Milk</div>
            </div>
            <v-menu
              v-model="editRecordAtPicker"
              :close-on-content-click="false"
              transition="scale-transition"
              location="bottom"
              max-width="290px"
              min-width="290px"
            >
              <template v-slot:activator="{ props }">
                <v-text-field
                  v-model="recordedAt"
                  label="Time"
                  prepend-icon="mdi-clock-time-four-outline"
                  :rules="[rules]"
                  readonly
                  v-bind="props"
                  variant="outlined"
                  density="compact"
                  class="mb-3"
                ></v-text-field>
              </template>
              <v-time-picker
                v-if="editRecordAtPicker"
                v-model="recordedAt"
                @update:modelValue="(val) => { changeRecordedAt(val); editRecordAtPicker = false; }"
                full-width
                format="24hr"
                :allowed-minutes="allowedStep"
              ></v-time-picker>
            </v-menu>

            <div class="d-flex align-baseline mb-3">
              <v-select
                v-model="amount"
                @update:modelValue="changeAmount"
                :items="milkChoice"
                item-title="value"
                item-value="id"
                :rules="[rules]"
                label="Amount"
                variant="outlined"
                density="compact"
              ></v-select>
              <p class="ml-1 body-1">cc</p>
            </div>

            <div class="d-flex align-baseline">
              <v-select
                v-model="milkCategory"
                @update:modelValue="changeMilkCategory"
                :items="optionsMilk"
                item-title="text"
                item-value="value"
                :rules="[rules]"
                label="Milk"
                variant="outlined"
                density="compact"
              ></v-select>
            </div>
          </template>

        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-row class="mt-2 mb-2">
            <v-col cols="4" class="pr-2 pl-2">
              <v-btn class="" color="#6C6C6C" dark variant="flat" width="100%" @click="editRecordDialog = false">
                <div>
                  <div class="text-h6 font-weight-bold message-btn">Cancel</div>
                </div>
              </v-btn>
            </v-col>

            <v-col cols="4" class="pl-1 pr-2">
              <v-btn
                class=""
                color="error"
                variant="outlined"
                width="100%"
                @click="remove(otherRecord)"
                :loading="loading"
              >
                <div>
                  <div class="text-body-2 font-weight-bold message-btn">Delete</div>
                </div>
              </v-btn>
            </v-col>

            <v-col cols="4" class="pl-1 pr-2">
              <v-btn
                class=""
                color="primary"
                variant="flat"
                width="100%"
                @click="change(otherRecord)"
                :disabled="!isSaveOtherRecord"
                :loading="loading"
              >
                <div>
                  <div class="text-h6 font-weight-bold message-btn">Save</div>
                </div>
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </div>
</template>
<script lang="ts">
import { defineComponent } from "vue";

import { childDiaryDetailModule } from "@/store/dataModules/childDiaryDetailModule";
import dayjs from "dayjs";
import 'dayjs/locale/ja';
dayjs.locale('ja');
import { attendanceEditModule } from "@/store/dataModules/attendanceEditModule";
import { 
  DefecationStatus, 
  DefecationStatusType, 
  MealStatus, 
  MealStatusType, 
  NurseryAttendanceResponse, 
  NurseryDefecationResponse, 
  NurseryMilkResponse, 
  NurseryTemperatureResponse, 
} from "chaild-api/lib";

interface DataType {
  date: string | null;
  childId: number | null;
  loading: boolean;
  addRecordDialog: boolean; // 記録追加モーダル元
  editRecordDialog: boolean; // 記録編集モーダル元
  isRecordetAtPicker: boolean; // モーダル表示
  editRecordAtPicker: boolean;
  otherRecord: string; // 表示項目
  defecation: DefecationStatusType; // 排便
  defecationRecord: NurseryDefecationResponse | null;
  choices: any; // 排便状態
  temperature: number; // 体温
  temperatureRecord: NurseryTemperatureResponse | null;
  amount: any; // ミルク量
  milkCategory: string; // ミルク種類
  milkRecord: NurseryMilkResponse | null;
  recordedAt: string; // 時間(HH:mm)
  editRecordedAt: string; // 時間(yyyy-mm-ddT00:00:00.000Z)
  content: string | null; // 活動記録/発達情報
  statusList: any; // 喫食状態
  showMenuItem: MenuRecord; // 喫食項目
  mealRecord: MealRecord; // 喫食内容
}

// 喫食項目
interface MenuRecord {
  stapleFood: boolean;
  mainDish: boolean;
  sideDish: boolean;
  soup: boolean;
  dessert: boolean;
  milk: boolean;
  snack: boolean;
}

// 喫食内容
interface MealRecord {
  stapleFood: MealStatusType | undefined;
  mainDish: MealStatusType | undefined;
  sideDish: MealStatusType | undefined;
  soup: MealStatusType | undefined;
  dessert: MealStatusType | undefined;
  milk: MealStatusType | undefined;
  snack: MealStatusType | undefined;
}

export default defineComponent({
  data: (): DataType => {
    return {
      date: null,
      childId: null,
      loading: false,
      addRecordDialog: false,
      editRecordDialog: false,
      isRecordetAtPicker: false,
      editRecordAtPicker: false,
      otherRecord: "",
      defecation: DefecationStatus.normal,
      defecationRecord: null,
      choices: [
        {
          text: 'Hard',
          value: DefecationStatus.hard,
        },
        {
          text: 'Normal',
          value: DefecationStatus.normal,
        },
        {
          text: 'Soft',
          value: DefecationStatus.soft,
        },
        {
          text: 'Watery (Diarrhea)',
          value: DefecationStatus.diarrhea,
        },
      ],
      temperature: 365 / 10,
      temperatureRecord: null,
      amount: null,
      milkCategory: 'breast',
      milkRecord: null,
      recordedAt: "",
      editRecordedAt: "",
      content: '',
      statusList: [
        { status: MealStatus.refill, title: 'Seconds' },
        { status: MealStatus.finished, title: 'Ate All' },
        { status: MealStatus.unfinished, title: 'Left a Little' },
        { status: MealStatus.half, title: 'Ate Half' },
        { status: MealStatus.little, title: 'Ate a Little' },
        { status: MealStatus.notEat, title: 'Did Not Eat' },
        { status: MealStatus.notServed, title: 'Not Served' },
      ],
      mealRecord: {
        stapleFood: undefined,
        mainDish: undefined,
        sideDish: undefined,
        soup: undefined,
        dessert: undefined,
        milk: undefined,
        snack: undefined,
      },
      showMenuItem: {
        stapleFood: false,
        mainDish: false,
        sideDish: false,
        soup: false,
        dessert: false,
        milk: false,
        snack: false,
      },
    };
  },

  watch: {
    addRecordDialog: {
      handler(val) {
        // 追加モーダルが閉じられたとき全てリセット
        if (!val) {
          this.isRecordetAtPicker = false;
          this.recordedAt = "";
          this.editRecordedAt = "";
          this.temperature = 365 / 10;
          this.defecation = DefecationStatus.normal;
          this.amount = null;
          this.milkCategory = "breast";
          this.otherRecord = '';
        }
      },
    },
    editRecordDialog: {
      handler(val) {
        // 編集モーダルが閉じられたとき全てリセット
        if (!val) {
          this.editRecordAtPicker = false;
          this.recordedAt = "";
          this.editRecordedAt = "";
          this.temperature = 365 / 10;
          this.defecation = DefecationStatus.normal;
          this.amount = null;
          this.milkCategory = "breast";
          this.otherRecord = '';
          this.defecationRecord = null;
          this.temperatureRecord = null;
          this.milkRecord = null;
        }
      },
    },
  },

  computed: {
    report() {
      return childDiaryDetailModule.report;
    },
    diary() {
      return childDiaryDetailModule.diary;
    },
    displayDate(): string {
      const value = this.date ?? this.diary?.date;
      return value ? dayjs(value).format("DD/MM/YYYY") : "";
    },
    attendance(): NurseryAttendanceResponse | null {
      return attendanceEditModule.attendance;
    },
    // 体温選択
    optionsTemperature() {
      const options: Array<{ text: string; value: number }> = [];
      for (let i = 350; i < 400; i++) {
        options.push({
          text: `${(i / 10).toFixed(1)}℃`,
          value: Number((i / 10).toFixed(1)),
        });
      }
      return options;
    },
    // ミルク量選択
    milkChoice() {
      const Choice: Array<{ id: number | null; value: number | string }> = [];
      let i = 0;
      for (let v = 0; v < 310; v += 10) {
        Choice.push({
          id: i,
          value: Number(v),
        })
        i++;
      }
      Choice.unshift({
        id: null,
        value: 'Unknown',
      });
      return Choice;
    },
    // ミルク種類選択
    optionsMilk() {
      const options = [
        { value: 'breast', text: 'Breast Milk' },
        { value: 'formula', text: 'Formula' },
      ];
      return options;
    },
    // 保存ボタンのアクティブ
    isSaveContent(): boolean {
      if (!this.content) {
        return false
      } else if (this.content != this.diary?.content) {
        return true;
      }
      return false;
    },
    // 保存ボタンのアクティブ
    isSaveOtherRecord(): boolean {
      if (this.recordedAt && this.recordedAt != null && this.defecation) {
        return true;
      } else if (this.recordedAt && this.recordedAt != null && this.temperature) {
        return true;
      } else if (this.recordedAt && this.recordedAt != null && this.amount) {
        return true;
      }
      return false;
    },
  },

  methods: {
    formatMealStatus(status: string) {
      if (status === "finished") {
        return "Ate All";
      } else if (status === "refill") {
        return "Seconds";
      } else if (status === "unfinished") {
        return "Left a Little";
      } else if (status === "half") {
        return "Ate Half";
      } else if (status === "little") {
        return "Ate a Little";
      } else if (status === "notEat") {
        return "Did Not Eat";
      } else if (status === "notServed") {
        return "Not Served";
      }
    },
    formatDefecation(defecation: string) {
      if (defecation === "hard") {
        return "Hard";
      } else if (defecation === "normal") {
        return "Normal";
      } else if (defecation === "soft") {
        return "Soft";
      } else if (defecation === 'diarrhea') {
        return 'Watery (Diarrhea)';
      }
    },
    async getAttendance(input: { childId: string; date: string }) {
      attendanceEditModule.setChildId(Number(input.childId));
      attendanceEditModule.setDate(input.date);
      await attendanceEditModule.getAttendance();
    },
    formatDate(date: string | null | undefined) {
      if (date) {
        return dayjs(date).format("HH:mm");
      }
      return null;
    },
    formatTemperature(value: number): string {
      return value.toFixed(1);
    },
    // 入力事項
    rules: (value: any) => !!value || 'This field is required',
    // ステップ
    allowedStep: (m: any) => m % 5 === 0,
    // 時間フォーマット
    formatTime(time: string) {
      const nowTime = dayjs(time).format('HH:mm');
      return nowTime;
    },
    // 時間が選択された時の処理
    changeRecordedAt(val: string) {
      // ⭕️ 修正: 空文字やnullの場合は何もせずeditRecordedAtも空にする
      if (!val) {
        this.recordedAt = "";
        this.editRecordedAt = "";
        return;
      }

      this.recordedAt = val;

      const recordedAtHour = val.split(':')[0];
      const recordedAtMinutes = val.split(':')[1];
      
      let baseDate = this.date;
      if (!baseDate && this.diary) {
          baseDate = this.diary.date;
      }
      if (!baseDate) {
          baseDate = dayjs().format("YYYY-MM-DD");
      }
      const recordedAtTime = dayjs(baseDate)
        .hour(Number(recordedAtHour))
        .minute(Number(recordedAtMinutes))
        .second(0);
        
      this.editRecordedAt = recordedAtTime.toISOString();
    },
    // 追加モーダル別表示
    changeAddOtherRecord(value: string) {
      this.otherRecord = value;
      this.recordedAt = ""; 
      this.editRecordedAt = "";
      this.addRecordDialog = true;
    },
    // 排便記録編集モーダル
    changeEditDefecation(defecation: NurseryDefecationResponse) {
      this.otherRecord = 'defecation';
      this.defecationRecord = defecation;
      this.recordedAt = this.formatTime(defecation.recordedAt); // ⭕️ 画面用にHH:mmをセット
      this.editRecordedAt = defecation.recordedAt;              // ⭕️ 保存用に元データをセット
      this.editRecordDialog = true;
    },
    // 体温記録編集モーダル
    changeEditTemperature(temperature: NurseryTemperatureResponse) {
      this.otherRecord = 'temperature';
      this.temperatureRecord = temperature;
      this.recordedAt = this.formatTime(temperature.recordedAt); // ⭕️ 画面用にHH:mmをセット
      this.editRecordedAt = temperature.recordedAt;              // ⭕️ 保存用に元データをセット
      this.editRecordDialog = true;
    },
    // ミルク記録編集モーダル
    changeEditMilk(milk: NurseryMilkResponse) {
      this.otherRecord = 'milk';
      this.milkRecord = milk;
      this.recordedAt = this.formatTime(milk.recordedAt); // ⭕️ 画面用にHH:mmをセット
      this.editRecordedAt = milk.recordedAt;              // ⭕️ 保存用に元データをセット
      this.editRecordDialog = true;
    },
    // 排便
    changeDefecationState(defecation: DefecationStatusType) {
      this.defecation = defecation;
    },
    // 体温
    changeTemperature(temperature: number) {
      this.temperature = temperature;
    },
    // ミルク量
    changeAmount(amount: number) {
      this.amount = amount;
    },
    // ミルク種類
    changeMilkCategory(milkCategory: string) {
      this.milkCategory = milkCategory;
    },
    // 喫食情報取得
    getMeal() {
      if (this.report?.nursery.meal) {
        this.mealRecord.stapleFood = this.report.nursery.meal.stapleFood;
        this.mealRecord.mainDish = this.report.nursery.meal.mainDish;
        this.mealRecord.sideDish = this.report.nursery.meal.sideDish;
        this.mealRecord.soup = this.report.nursery.meal.soup;
        this.mealRecord.dessert = this.report.nursery.meal.dessert;
        this.mealRecord.milk = this.report.nursery.meal.milk;
        this.mealRecord.snack = this.report.nursery.meal.snack;
      }
    },
    // 喫食記録追加
    async createMealReport() {
      this.loading = true
      if (this.childId && this.date) {
        await childDiaryDetailModule.createMeal({
          childId: this.childId,
          date: this.date,
          stapleFood: 'notServed',
          mainDish: 'notServed',
          sideDish: 'notServed',
          soup: 'notServed',
          dessert: 'notServed',
          milk: 'notServed',
          snack: 'notServed',
          comment: '',
        })
      }
      await childDiaryDetailModule.getDailyReport();
      await childDiaryDetailModule.getDiary();
      this.getMeal()
      this.loading = false
    },
    // 喫食状態を全て完食に変更
    fullEat() {
      this.mealRecord.stapleFood = 'finished';
      this.mealRecord.mainDish = 'finished';
      this.mealRecord.sideDish = 'finished';
      this.mealRecord.soup = 'finished';
      this.mealRecord.dessert = 'finished';
      this.mealRecord.milk = 'finished';
      // this.mealRecord.snack = 'finished';
      this.saveMeal()
    },
    // 喫食選択
    showMenu(value: string) {
      switch (value) {
        case 'stapleFood':
          this.showMenuItem.stapleFood = true;
          return
        case 'mainDish':
          this.showMenuItem.mainDish = true;
          return
        case 'sideDish':
          this.showMenuItem.sideDish = true;
          return
        case 'soup':
          this.showMenuItem.soup = true;
          return
        case 'dessert':
          this.showMenuItem.dessert = true;
          return
        case 'milk':
          this.showMenuItem.milk = true;
          return
        case 'snack':
          this.showMenuItem.snack = true;
          return
        default:
          return
      }
    },
    // 喫食内容変更
    changeMealStatus(value: string, status: MealStatusType) {
      switch (value) {
        case 'stapleFood':
          if (this.mealRecord.stapleFood == status) {
            return
          }
          this.mealRecord.stapleFood = status;
          break
        case 'mainDish':
          if (this.mealRecord.mainDish == status) {
            return
          }
          this.mealRecord.mainDish = status;
          break
        case 'sideDish':
          if (this.mealRecord.sideDish == status) {
            return
          }
          this.mealRecord.sideDish = status;
          break
        case 'soup':
          if (this.mealRecord.soup == status) {
            return
          }
          this.mealRecord.soup = status;
          break
        case 'dessert':
          if (this.mealRecord.dessert == status) {
            return
          }
          this.mealRecord.dessert = status;
          break
        case 'milk':
          if (this.mealRecord.milk == status) {
            return
          }
          this.mealRecord.milk = status;
          break
        case 'snack':
          if (this.mealRecord.snack == status) {
            return
          }
          this.mealRecord.snack = status;
          break
        default:
          break
      }
      this.saveMeal()
    },
    // 喫食情報保存
    async saveMeal() {
      this.loading = true;
      if (this.childId && this.report?.nursery.meal) {
        await childDiaryDetailModule.updateMeal({
          childId: this.childId,
          mealId: this.report.nursery.meal.mealId,
          stapleFood: this.mealRecord.stapleFood,
          mainDish: this.mealRecord.mainDish,
          sideDish: this.mealRecord.sideDish,
          soup: this.mealRecord.soup,
          dessert: this.mealRecord.dessert,
          milk: this.mealRecord.milk,
          snack: this.mealRecord.snack,
        })
      } 
      await childDiaryDetailModule.getDailyReport();
      await childDiaryDetailModule.getDiary();
      this.getMeal()
      this.loading = false;
      return
    },
    // 保存
    async save(value: string) {
      this.loading = true;
      let targetDate = this.date;
      if (!targetDate && this.diary) {
        targetDate = this.diary.date;
      }
      
      if (this.childId && targetDate) {
        switch (value) {
          case 'defecation':
            await childDiaryDetailModule.saveDefecation({
            childId: this.childId,
            date: targetDate,
            recordedAt: this.editRecordedAt,
            state: this.defecation
            })
            break
          case 'temperature':
            await childDiaryDetailModule.saveTemperature({
              childId: this.childId,
              date: targetDate,
              recordedAt: this.editRecordedAt,
              temperature: this.temperature,
            })
            break
          case 'milk':
            await childDiaryDetailModule.saveMilk({
              childId: this.childId,
              date: targetDate,
              recordedAt: this.editRecordedAt,
              amountId: this.amount,
              milkCategory: this.milkCategory,
            })
            break
          default:
            break
        }
      } else {
        this.loading = false;
        return alert(this.$t('ui.saveFailed'))
      }
      await childDiaryDetailModule.getDailyReport();
      await childDiaryDetailModule.getDiary();
      this.loading = false;
      this.addRecordDialog = false;
    },
    // 変更
    async change(value: string) {
      this.loading = true;
      if (this.childId) {
        switch (value) {
          case 'defecation':
            if (this.defecationRecord) {
              await childDiaryDetailModule.updateDefecation({
              childId: this.childId,
              defecationId: this.defecationRecord?.defecationId,
              recordedAt: this.editRecordedAt,
              state: this.defecation
              })
            }
            break
          case 'temperature':
            if (this.temperatureRecord) {
              await childDiaryDetailModule.updateTemperature({
                childId: this.childId,
                temperatureId: this.temperatureRecord.temperatureId,
                recordedAt: this.editRecordedAt,
                temperature: this.temperature,
              })
            }
            break
          case 'milk':
            if (this.milkRecord) {
              await childDiaryDetailModule.updateMilk({
                childId: this.childId,
                milkId: this.milkRecord.milkId,
                recordedAt: this.editRecordedAt,
                amountId: this.amount,
                milkCategory: this.milkCategory,
              })
            }
            break
          default:
            break
        }
      } else {
        this.loading = false;
        return alert(this.$t('ui.updateFailed'))
      }
      await childDiaryDetailModule.getDailyReport();
      await childDiaryDetailModule.getDiary();
      this.editRecordDialog = false;
      this.loading = false;
    },
    // 削除
    async remove(value: string) {
      this.loading = true;
      if (this.childId) {
        switch (value) {
          case 'defecation':
            if (this.defecationRecord) {
              await childDiaryDetailModule.deleteDefecation({
                childId: this.childId,
                defecationId: this.defecationRecord.defecationId
              })
            }
            break
          case 'temperature':
            if (this.temperatureRecord) {
              await childDiaryDetailModule.deleteTemperature({
                childId: this.childId,
                temperatureId: this.temperatureRecord.temperatureId
              })
            }
            break
          case 'milk':
            if (this.milkRecord) {
              await childDiaryDetailModule.deleteMilk({
                childId: this.childId,
                milkId: this.milkRecord.milkId
              })
            }
            break
          default:
            break
        }
      } else {
        this.loading = false;
        return alert(this.$t('ui.deleteFailed'))
      }
      await childDiaryDetailModule.getDailyReport();
      await childDiaryDetailModule.getDiary();
      this.loading = false;
      this.editRecordDialog = false;
    },
    // 活動記録/発達状況の保存
    async saveContent() {
      if (this.content) {
        this.loading = true;
        if (this.diary && this.childId){
          await childDiaryDetailModule.updateContent({
            childId: this.childId,
            diaryId: this.diary.diaryId,
            content: this.content,
          })
        }
      } else {
        // ふつうは通ることがない
        this.loading = false
        return alert(this.$t('ui.noRecord'))
      }
      await childDiaryDetailModule.getDailyReport();
      await childDiaryDetailModule.getDiary();
      if (this.diary) {
        this.content = this.diary.content
      }
      this.loading = false
      return this.content
    },
  },
  async mounted() {
    this.loading = true
    const childId = this.$route.params.childId as string;
    const date = this.$route.params.date as string;

    if (childId && date) {
      try {
        const parsed = parseInt(childId);
        childDiaryDetailModule.setChildId(parsed);
        childDiaryDetailModule.setDate(date);

        await childDiaryDetailModule.getDailyReport();
        await childDiaryDetailModule.getDiary();

        await this.getAttendance({
          childId: childId,
          date: date,
        });

        this.date = date;
        this.childId = parsed;
      } catch {
        this.loading = false
        return;
      }
    }
    if (this.diary) {
      this.content = this.diary.content
      }
    this.getMeal()
    this.loading = false
  },
});
</script>
<style lang="scss" scoped>
.report-table-header {
  font-weight: bold;
  width: 100px !important;
}

.circle-back-notEat,
.circle-back-little,
.circle-back-half,
.circle-back-unfinished,
.circle-back-finished,
.circle-back-refill {
  height: 34px;
  width: 34px;
  border-radius: 100%;
  background-color: #176ed3;
}
.circle-back-notServed {
  height: 34px;
  width: 34px;
  background-color: white;
}
.circle-front-notEat {
  height: 30px;
  width: 30px;
  top: 2px;
  left: 2px;
  border-radius: 100%;
  background-color: white;
  position: absolute;
}

.circle-front-little {
  height: 22px;
  width: 30px;
  top: 2px;
  left: 2px;
  border-radius: 22px 22px 5px 5px;
  background-color: white;
  position: absolute;
}
.circle-front-half {
  height: 15px;
  width: 30px;
  top: 2px;
  left: 2px;
  border-radius: 15px 15px 0px 0px;
  background-color: white;
  position: absolute;
}

.circle-front-unfinished {
  height: 15px;
  width: 30px;
  top: 2px;
  left: 2px;
  border-radius: 15px 15px 0px 0px;
  background-color: white;
  position: absolute;
  // border-top: 3px solid #ff6c00;
  // border-right: 1px solid #ff6c00;
  border-bottom: 7px solid #176ed3;
  // border-left: 1px solid #ff6c00;
}

.circle-front-finished {
  height: 30px;
  width: 30px;
  top: 1px;
  left: 1px;
  border-radius: 100%;
  background-color: #176ed3;
  position: absolute;
}

.circle-front-refill {
  height: 34px;
  width: 34px;
  left: 7px;
  border-radius: 100%;
  background-color: #176ed3;
  border: 1px solid white;
  position: absolute;
}

.circle-front-notServed {
  height: 5px;
  width: 34px;
  top: 17px;
  background-color: #c4c4c4;
  position: absolute;
}
</style>